import update from 'immutability-helper';

import { handleActions } from 'redux-actions';

import { initialState } from './initialize-state';
import {
  LOAD_ADDRESS_BOOK,
  LOAD_ADDRESS_BOOK_SUCCESS,
  LOAD_ADDRESS_BOOK_ERROR,
} from '../type';

const packageReducer = handleActions(
  new Map([
    [
      LOAD_ADDRESS_BOOK,
      state => {
        return update(state, {
          loadingStatus: {
            addressBookLoading: { $set: true },
          },
        });
      },
    ],
    [
      LOAD_ADDRESS_BOOK_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            addressBookLoading: { $set: false },
          },
          addressBook: {
            $set: action.payload,
          },
        });
      },
    ],
    [
      LOAD_ADDRESS_BOOK_ERROR,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            addressBookLoading: { $set: false },
          },
          error: { $set: action.payload },
        });
      },
    ],
  ]),
  initialState,
);
export default packageReducer;
